<template>
  <div class="my-video-container">
    <!-- <video preload="metadata" ref="videoPlayer" :poster="posterImage" controls 
      style="object-fit: contain;"></video> -->
    <!-- <video preload="metadata" ref="videoPlayer" :poster="posterImage"  controls muted autoplay
      style="object-fit: contain;"></video> -->
      <video preload="metadata" ref="videoPlayer" :poster="posterImage"  controls muted autoplay
      style="object-fit: contain;" crossorigin="anonymous"></video>
  <div v-if="isPlaylist" class="video-overlay-buttons">
      <v-btn icon dark elevation="0" class="mr-3 video-previous" @click="onPreviousClick">
        <v-icon>mdi-skip-previous</v-icon>
      </v-btn>
      <v-btn icon dark elevation="0" class="ml-3 video-next" @click="onNextClick">
        <v-icon>mdi-skip-next</v-icon>
      </v-btn>
    </div>
    <div
      v-if="showSubtitles && currentSubtitle"
      ref="subtitleOverlay"
      class="subtitle-overlay"
    >
      <span>{{ currentSubtitle }}</span>
    </div>
  </div>

</template>

<script>
import Plyr from 'plyr';
import Hls from 'hls.js';
import 'plyr/dist/plyr.css';
import AssetApi from '@/api/asset/AssetApi.js';

export default {
  data() {
    return {
      posterImage: null,
      videoList: [],
      isPlaylist: false,
      player: null,
      hls: null,
      hlsUrl: null,
      currentIdx: 0,
      showButtons: false,
      uuid: null,
      subtitleSrc: null,
      subtitleAvailable: false,
      transcriptLoading: false,
      transcriptFetched: false,
      isSilentVideo: false,
      subtitleCues: [],
      subtitleTrackEl: null,
      showSubtitles: false,
      currentSubtitle: '',
      subtitleUpdateTimer: null,
      subtitleButtonEl: null,
      subtitleButtonListener: null,
      subtitleButtonEl: null,
      assetId: null,
      fullscreenEventsRegistered: false,
      // encCheck: null,
      // status: null,
    };
  },
  computed: {
    subtitleToggleLabels() {
      const t = this.$store?.getters?.t;
      const translate = (key, fallback) => (t ? t(key) : fallback);
      return {
        on: translate('ai.subtitle.toggle.on', '자막끄기'),
        off: translate('ai.subtitle.toggle.off', '자막켜기'),
        loading: translate('ai.subtitle.toggle.preparing', '자막 준비중'),
        silent: translate('ai.subtitle.toggle.silent', '소리없는 영상'),
      };
    },
    subtitleAriaLabel() {
      const t = this.$store?.getters?.t;
      return t ? t('ai.subtitle.player.aria_label') : 'AI subtitles';
    },
  },
  methods: {
    normalizeSource(value) {
      if (typeof value !== 'string') {
        return '';
      }
      let decoded = value;
      try {
        decoded = decodeURIComponent(value);
      } catch (error) {
        // ignore decode errors and fall back to original value
      }
      if (/^url=/i.test(decoded)) {
        decoded = decoded.slice(decoded.indexOf('=') + 1);
      }
      return decoded.trim();
    },
    formatTimestampForVtt(timestamp) {
      const safe = (timestamp || '').toString().replace(',', '.').trim();
      if (!safe) {
        return '00:00:00.000';
      }
      const [timePart, fraction = '000'] = safe.split('.');
      const timeSegments = timePart.split(':').map(seg => seg.padStart(2, '0'));
      while (timeSegments.length < 3) {
        timeSegments.unshift('00');
      }
      const normalizedFraction = fraction.padEnd(3, '0').slice(0, 3);
      return `${timeSegments.slice(-3).join(':')}.${normalizedFraction}`;
    },
    convertCuesToVtt(cues) {
      const lines = ['WEBVTT', ''];
      cues.forEach((cue) => {
        const start = this.formatTimestampForVtt(cue.start);
        const end = this.formatTimestampForVtt(cue.end);
        const text = (cue.text || '').toString();
        lines.push(`${start} --> ${end}`);
        lines.push(text);
        lines.push('');
      });
      return lines.join('\n');
    },
    extractUuidFromUrl(url) {
      if (!url) {
        return null;
      }
      const findSegment = (pattern) => {
        const idx = url.indexOf(pattern);
        if (idx === -1) return null;
        const start = idx + pattern.length;
        const segment = url.slice(start).split('/')[0];
        return segment || null;
      };
      const uploadUuid = findSegment('/upload/');
      if (uploadUuid) {
        return uploadUuid;
      }
      const encodedUuid = findSegment('/encoded/');
      if (encodedUuid) {
        return encodedUuid;
      }
      const smilUuid = findSegment('smil:');
      if (smilUuid) {
        return smilUuid.replace(/\.smil$/, '');
      }
      const genericMatch = url.match(/([0-9a-fA-F-]{8,})/);
      if (genericMatch && genericMatch[1]) {
        return genericMatch[1];
      }
      return null;
    },
    refreshCaptionMenu(autoToggle = false) {
      const video = this.$refs.videoPlayer;
      if (!video || !video.textTracks) {
        return;
      }
      for (let i = 0; i < video.textTracks.length; i += 1) {
        const track = video.textTracks[i];
        if (track.kind === 'captions') {
          track.mode = autoToggle ? 'showing' : 'hidden';
        }
      }
      if (this.player && this.player.captions && typeof this.player.captions.update === 'function') {
        try {
          this.player.captions.update();
          if (autoToggle) {
            this.player.captions.toggle(true);
          }
        } catch (error) {
          // ignore caption update errors
        }
      }
    },
    attachCaptionListeners(autoToggle = false) {
      const trackEl = this.subtitleTrackEl;
      if (!trackEl) {
        this.refreshCaptionMenu(false);
        return;
      }
      const apply = () => {
        this.refreshCaptionMenu(autoToggle);
      };
      const onceHandler = () => {
        apply();
        trackEl.removeEventListener('load', onceHandler);
      };
      trackEl.addEventListener('load', onceHandler);
      if (trackEl.readyState === 2) {
        apply();
        trackEl.removeEventListener('load', onceHandler);
      }
    },
    clearCaptionTrack() {
      this.subtitleTrackEl = null;
      this.subtitleAvailable = false;
      this.refreshCaptionMenu(false);
    },
    installCaptionTrack() {
      // Placeholder to keep existing API surface; no longer inserting native track.
    },
    installCustomControls() {
      if (!this.player || this.subtitleButtonEl) {
        return;
      }
      const controls = this.player.elements && this.player.elements.controls;
      if (!controls) {
        return;
      }

      const btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'plyr__controls__item plyr__control subtitle-toggle-control';
      btn.setAttribute('type', 'button');
      btn.setAttribute('aria-label', this.subtitleAriaLabel);

      const labelEl = document.createElement('span');
      labelEl.className = 'subtitle-toggle-label';
      labelEl.textContent = this.subtitleToggleLabels.off;
      btn.appendChild(labelEl);

      controls.appendChild(btn);
      this.subtitleButtonEl = btn;
      this.subtitleButtonListener = async (event) => {
        event.preventDefault();
        event.stopPropagation();
        if (this.transcriptLoading) {
          return;
        }
        this.subtitleButtonEl.blur();
        this.subtitleButtonEl.disabled = true;
        try {
          await this.toggleSubtitleOverlay();
        } finally {
          this.subtitleButtonEl.disabled = false;
          this.updateSubtitleButtonState();
        }
      };
      this.subtitleButtonEl.addEventListener('click', this.subtitleButtonListener, false);
      this.updateSubtitleButtonState();
    },
    disposeCustomControls() {
      if (this.subtitleButtonEl && this.subtitleButtonListener) {
        this.subtitleButtonEl.removeEventListener('click', this.subtitleButtonListener, false);
      }
      if (this.subtitleButtonEl && this.subtitleButtonEl.parentNode) {
        this.subtitleButtonEl.parentNode.removeChild(this.subtitleButtonEl);
      }
      this.subtitleButtonListener = null;
      this.subtitleButtonEl = null;
    },
    updateSubtitleButtonState() {
      if (!this.subtitleButtonEl) {
        return;
      }
      const hasSubs = this.subtitleAvailable;
      let label;
      if (this.isSilentVideo) {
        label = this.subtitleToggleLabels.silent;
      } else if (this.showSubtitles) {
        label = this.subtitleToggleLabels.on;
      } else {
        label = hasSubs ? this.subtitleToggleLabels.off : this.subtitleToggleLabels.loading;
      }
      const disabled = this.transcriptLoading || this.isSilentVideo;
      this.subtitleButtonEl.disabled = disabled;
      this.subtitleButtonEl.setAttribute('aria-disabled', disabled ? 'true' : 'false');
      this.subtitleButtonEl.setAttribute('aria-pressed', this.showSubtitles ? 'true' : 'false');
      this.subtitleButtonEl.setAttribute('aria-label', this.subtitleAriaLabel);
      const labelEl = this.subtitleButtonEl.querySelector('.subtitle-toggle-label');
      if (labelEl) {
        labelEl.textContent = label;
      }
      this.subtitleButtonEl.classList.toggle('subtitle-toggle-control--active', this.showSubtitles);
    },
    async loadTranscript(autoToggle = false) {
      if (this.transcriptLoading) {
        return;
      }
      this.transcriptLoading = true;
      this.updateSubtitleButtonState();
      try {
        this.isSilentVideo = false;
        let data = null;

        if (this.uuid) {
          try {
            data = await AssetApi.getTranscriptByAid(this.uuid);
          } catch (error) {
            data = null;
          }
          if (!data) {
            try {
              data = await AssetApi.getTranscriptByUuid(this.uuid);
            } catch (error) {
              data = null;
            }
          }
        }

        if (!data && this.assetId) {
          try {
            data = await AssetApi.getTranscript(this.assetId);
          } catch (error) {
            data = null;
          }
        }

        if (!data) {
          this.subtitleAvailable = false;
          if (this.subtitleSrc) {
            URL.revokeObjectURL(this.subtitleSrc);
            this.subtitleSrc = null;
          }
          this.clearCaptionTrack();
          this.transcriptFetched = false;
          this.updateSubtitleButtonState();
          return false;
        }

        const status = typeof data?.status === 'string' ? data.status : null;
        this.isSilentVideo = status === 'no-audio';

        if (this.isSilentVideo) {
          if (this.subtitleSrc) {
            URL.revokeObjectURL(this.subtitleSrc);
          }
          this.subtitleSrc = null;
          this.subtitleAvailable = false;
          this.subtitleCues = [];
          this.transcriptFetched = true;
          this.updateSubtitleButtonState();
          return false;
        }

        this.transcriptFetched = true;
        this.subtitleCues = Array.isArray(data?.cues) ? data.cues : [];
        this.subtitleAvailable = this.subtitleCues.length > 0;

        if (this.subtitleAvailable) {
          if (this.subtitleSrc) {
            URL.revokeObjectURL(this.subtitleSrc);
          }
          const vtt = this.convertCuesToVtt(this.subtitleCues);
          const blob = new Blob([vtt], { type: 'text/vtt' });
          this.subtitleSrc = URL.createObjectURL(blob);
          this.installCaptionTrack(autoToggle);
          this.updateSubtitleButtonState();
        } else {
          if (this.subtitleSrc) {
            URL.revokeObjectURL(this.subtitleSrc);
            this.subtitleSrc = null;
          }
          this.clearCaptionTrack();
          this.updateSubtitleButtonState();
        }
      } catch (error) {
        console.warn('자막 정보를 불러오지 못했습니다.', error);
        this.subtitleAvailable = false;
        this.isSilentVideo = false;
        this.clearCaptionTrack();
        this.transcriptFetched = false;
        this.updateSubtitleButtonState();
        return false;
      } finally {
        this.transcriptLoading = false;
        this.updateSubtitleButtonState();
      }
      return this.subtitleAvailable;
    },
    ensureTranscriptLoaded(autoToggle = false) {
      if (this.isSilentVideo) {
        return Promise.resolve(false);
      }
      if (this.subtitleAvailable) {
        return Promise.resolve(true);
      }
      if (this.transcriptLoading) {
        return new Promise((resolve) => {
          const check = () => {
            if (!this.transcriptLoading) {
              resolve(this.subtitleAvailable);
            } else {
              requestAnimationFrame(check);
            }
          };
          check();
        });
      }
      if (!this.transcriptFetched) {
        return this.loadTranscript(autoToggle);
      }
      return Promise.resolve(this.subtitleAvailable);
    },
    async toggleSubtitleOverlay() {
      if (this.isSilentVideo) {
        this.showSubtitles = false;
        this.currentSubtitle = '';
        this.updateSubtitleButtonState();
        return;
      }
      if (!this.subtitleAvailable) {
        const available = await this.ensureTranscriptLoaded(true);
        if (!available) {
          this.showSubtitles = false;
          this.currentSubtitle = '';
          this.updateSubtitleButtonState();
          return;
        }
      }
      this.showSubtitles = !this.showSubtitles;
      if (this.showSubtitles) {
        this.$nextTick(() => {
          this.attachSubtitleOverlay();
          this.updateSubtitleOverlay();
        });
        this.startSubtitleTimer();
      } else {
        this.currentSubtitle = '';
        this.stopSubtitleTimer();
      }
      this.updateSubtitleButtonState();
    },
    updateSubtitleOverlay() {
      if (!this.showSubtitles || !Array.isArray(this.subtitleCues)) {
        this.currentSubtitle = '';
        return;
      }
      const media = (this.player && this.player.media) ? this.player.media : this.$refs.videoPlayer;
      if (!media || typeof media.currentTime !== 'number') {
        this.currentSubtitle = '';
        return;
      }
      const currentTime = media.currentTime;
      const matchedCue = this.subtitleCues.find((cue) => {
        const start = this.timeToSeconds(cue.start);
        const end = this.timeToSeconds(cue.end);
        return currentTime >= start && currentTime <= end;
      });
      this.currentSubtitle = matchedCue ? this.normalizeSubtitleText(matchedCue.text, media.clientWidth || this.$refs.videoPlayer.clientWidth || 0) : '';
    },
    startSubtitleTimer() {
      this.stopSubtitleTimer();
      this.subtitleUpdateTimer = setInterval(() => {
        this.updateSubtitleOverlay();
      }, 300);
    },
    stopSubtitleTimer() {
      if (this.subtitleUpdateTimer) {
        clearInterval(this.subtitleUpdateTimer);
        this.subtitleUpdateTimer = null;
      }
    },
    timeToSeconds(timeString) {
      if (!timeString) return 0;
      const normalized = timeString.replace(',', '.');
      const parts = normalized.split(':').map(Number);
      while (parts.length < 3) {
        parts.unshift(0);
      }
      const [hours, minutes, seconds] = parts;
      return (hours * 3600) + (minutes * 60) + seconds;
    },
    normalizeSubtitleText(text, playerWidth = 0) {
      if (!text) {
        return '';
      }
      const cleaned = text
        .toString()
        .replace(/(\r\n|\r|\n)+/g, ' ')
        .replace(/\s{2,}/g, ' ')
        .trim();
      const maxLineLength = this.estimateMaxLineLength(playerWidth);
      if (!maxLineLength || cleaned.length <= maxLineLength) {
        return cleaned;
      }
      const splitIndex = this.findSplitIndex(cleaned, maxLineLength);
      return `${cleaned.slice(0, splitIndex).trim()}\n${cleaned.slice(splitIndex).trim()}`;
    },
    estimateMaxLineLength(playerWidth) {
      const baseWidth = playerWidth && Number.isFinite(playerWidth) ? playerWidth : window.innerWidth;
      const pixelsPerChar = 12;
      let limit = Math.floor(baseWidth * 0.9 / pixelsPerChar);
      limit = Math.max(35, Math.min(limit, 80));
      return limit;
    },
    findSplitIndex(text, limit) {
      const punctuation = /[.!?,;:] /g;
      const half = Math.min(limit, Math.floor(text.length / 2));
      let chosen = -1;
      let match;
      while ((match = punctuation.exec(text))) {
        const idx = match.index + (match[0].endsWith(' ') ? 0 : 1);
        if (idx < limit && (chosen === -1 || Math.abs(idx - half) < Math.abs(chosen - half))) {
          chosen = idx;
        }
      }
      if (chosen === -1) {
        const spaces = [];
        for (let i = 0; i < text.length; i += 1) {
          if (text[i] === ' ') {
            spaces.push(i);
          }
        }
        chosen = spaces.reduce((best, idx) => {
          if (idx >= limit) {
            return best;
          }
          return (best === -1 || Math.abs(idx - half) < Math.abs(best - half)) ? idx : best;
        }, -1);
      }
      if (chosen === -1 || chosen <= 0) {
        return Math.min(limit, text.length - 1);
      }
      return chosen + 1;
    },
    attachSubtitleOverlay() {
      const overlayEl = this.$refs.subtitleOverlay;
      if (!overlayEl || !this.player || !this.player.elements) {
        return;
      }
      const container = this.player.elements.container;
      if (!container || overlayEl.parentNode === container) {
        return;
      }
      container.appendChild(overlayEl);
    },
    registerFullscreenEvents() {
      if (!this.player || this.fullscreenEventsRegistered !== false) {
        return;
      }
      const applyOverlay = () => {
        this.$nextTick(() => {
          this.attachSubtitleOverlay();
          this.updateSubtitleOverlay();
        });
      };
      this.player.on('enterfullscreen', applyOverlay);
      this.player.on('exitfullscreen', applyOverlay);
      this.fullscreenEventsRegistered = true;
    },
    async loadVideo(tmpNumber) {

      // const types = { mp4: 'video/mp4', webm: 'video/webm', m3u: 'application/x-mpegURL' };
      // const arr = tmpNumber.split(',');
      // this.isPlaylist = arr.length > 1;

      // for (let i = 0; i < arr.length; i++) {
      //   const add = {
      //     sources: [{
      //       src: decodeURIComponent(arr[i]),
      //       type: types.m3u
      //     }],
      //   };
      //   this.videoList.push(add);
      //   // console.log('this.isPlaylist', add);
      // }


      // this.player = new Plyr(this.$refs.videoPlayer, {
      //   debug: false,
      //   muted: true,
      //   // autoplay: true,
      // });

      // this.$refs.videoPlayer.muted = true;

      // const volumeInput = document.querySelector('input[data-plyr="volume"]');
      // if (volumeInput) {
      //   volumeInput.value = 0;
      //   volumeInput.dispatchEvent(new Event('input'));
      // }

      // this.player.source = this.videoList;

      // for (let i = 0; i < this.videoList.length; i++) {
      //   if (this.videoList[i].sources[0].src.indexOf('m3u8') > -1) {
      //     this.hlsUrl = this.videoList[i].sources[0].src;
      //     this.currentIdx = i;
      //     break;
      //   }
      // }

      // if (this.hlsUrl !== null && Hls.isSupported()) {
      //   this.hls = new Hls();
      //   this.hls.loadSource(this.hlsUrl);
      //   this.hls.attachMedia(this.$refs.videoPlayer);
      //   this.hls.on(Hls.Events.MANIFEST_PARSED, () => {
      //     this.$refs.videoPlayer.play();
      //   });
      // } else if (this.$refs.videoPlayer.canPlayType('application/vnd.apple.mpegurl')) {
      //     const video = this.$refs.videoPlayer;
      //     video.src = this.hlsUrl;
      //     video.addEventListener('canplay', function () {
      //       video.play();
      //     });
      // }
      const types = { mp4: 'video/mp4', webm: 'video/webm', m3u: 'application/x-mpegURL' };
      const arr = tmpNumber.split(',');
      this.isPlaylist = arr.length > 1;

      for (let i = 0; i < arr.length; i++) {
        const source = this.normalizeSource(arr[i]);
        if (!source) {
          continue;
        }
        const add = {
          sources: [{
            src: source,
            type: types.m3u
          }],
        };
        this.videoList.push(add);
      }

      for (let i = 0; i < this.videoList.length; i++) {
        if (this.videoList[i].sources[0].src.indexOf('m3u8') > -1) {
          this.hlsUrl = this.videoList[i].sources[0].src;
          this.currentIdx = i;
          break;
        }
      }

      if (this.hlsUrl !== null && Hls.isSupported()) {
        this.hls = new Hls();
        this.hls.loadSource(this.hlsUrl);
        this.hls.attachMedia(this.$refs.videoPlayer);

        this.hls.on(Hls.Events.MANIFEST_PARSED, () => {
          const isVertical = this.hls.levels[0].height > this.hls.levels[0].width;

          const levels = isVertical
            ? this.hls.levels.map(l => l.width)
            : this.hls.levels.map(l => l.height);

          const qualityOptions = [...new Set(levels)].sort((a, b) => b - a);
          
          // const levels = this.hls.levels.map(l => l.height);
          // const qualityOptions = [...new Set(levels)].sort((a, b) => b - a);
          // console.log("levels => ", qualityOptions)
          this.fullscreenEventsRegistered = false;
          this.player = new Plyr(this.$refs.videoPlayer, {
            debug: false,
            muted: true,
            captions: {
              active: false,
              language: 'ko',
              update: true,
            },
            speed: {
              selected: 1,
              options: [0.5, 0.75, 1, 1.25, 1.5, 2]
            },
            controls: [
              'play-large',
              'play',
              'progress',
              'current-time',
              'mute',
              'volume',
              'speed',
              'captions',
              'settings',
              'pip',
              'airplay',
              'fullscreen'
            ],
            settings: ['captions', 'quality', 'speed'],
            quality: {
              default: 'auto',
              options: ['auto', ...qualityOptions],
              forced: true,
              onChange: (newQuality) => {
                if (newQuality === 'auto') {
                  this.hls.currentLevel = -1;
                } else {
                  const levelIndex = this.hls.levels.findIndex(l => l.height === newQuality);
                  if (levelIndex !== -1) {
                    this.hls.currentLevel = levelIndex;
                  }
                }
              }
            }
          });
          this.player.on('ready', () => {
            this.installCaptionTrack(false);
            this.refreshCaptionMenu(false);
            this.installCustomControls();
            this.updateSubtitleButtonState();
            this.registerFullscreenEvents();
            this.$nextTick(() => {
              this.attachSubtitleOverlay();
            });
          });

          this.$refs.videoPlayer.muted = true;

          const volumeInput = document.querySelector('input[data-plyr="volume"]');
          if (volumeInput) {
            volumeInput.value = 0;
            volumeInput.dispatchEvent(new Event('input'));
          }

          this.$refs.videoPlayer.play();
        });
      } else if (this.$refs.videoPlayer.canPlayType('application/vnd.apple.mpegurl')) {
        const video = this.$refs.videoPlayer;
        video.src = this.hlsUrl;
        video.addEventListener('canplay', function () {
          video.play();
        });
        this.installCaptionTrack(false);
        this.refreshCaptionMenu(false);
        this.installCustomControls();
        this.updateSubtitleButtonState();
      }

    },

    async getPoster(tmpNumber) {
      try {
        const url = `${this.normalizeSource(tmpNumber)}`;
        this.uuid = this.extractUuidFromUrl(url);
        this.isSilentVideo = false;

        if (!this.uuid) {
          this.posterImage = '/streamon.png';
          this.subtitleSrc = null;
          this.subtitleAvailable = false;
          this.transcriptFetched = false;
          this.subtitleCues = [];
          this.clearCaptionTrack();
          this.updateSubtitleButtonState();
        } else {
          if (this.subtitleSrc) {
            URL.revokeObjectURL(this.subtitleSrc);
          }
          this.subtitleSrc = null;
          this.subtitleAvailable = false;
          this.subtitleCues = [];
          this.transcriptFetched = false;
          this.isSilentVideo = false;

          const params = { uuid: this.uuid };
          this.posterImage = await AssetApi.posterApi(params);
          await this.loadTranscript(false);
        }

        const img = new Image();
        img.src = this.posterImage;
        await new Promise((resolve) => {
          img.onload = resolve;
          img.onerror = resolve;
        });
        this.$refs.videoPlayer.poster = this.posterImage;
      } catch (error) {
        console.error('getPoster error :', error);
        this.clearCaptionTrack();
      }
    },

    // async setEnc(tmpNumber){
    //   try {
        
    //       const url = decodeURIComponent(tmpNumber) + "";
    //       const match = url.match(/upload\/([^/]+)\/([^/]+)/);
    //       if(match) {
    //         this.uuid = match[1];
    //         this.status = "upload";

    //         if(this.uuid == null || this.uuid == ''){
    //           const match = url.match(/encoded\/([^/]+)\/([^/]+)/);
    //           this.uuid =  match[1];
    //           this.status = "encoded";
    //         }

    //         const params = {
    //             uuid: this.uuid,
    //             status: this.status
    //         }

    //         this.encCheck = await AssetApi.encApi(params);

    //         // console.log("encCheck => ", this.encCheck);
    //       }
    //   } catch (error) {
    //       console.error("setEnc error :", error);
    //   }
    // },


    // async getPoster(){
    //   try {
    //     if(this.hlsUrl){
    //       const match = this.hlsUrl.match(/upload\/([^/]+)\/([^/]+)/);
    //       if(match) {
    //         this.uuid = match[1];
    //       }
    //       if(this.uuid == null || this.uuid == ''){
    //         const match = this.hlsUrl.match(/encoded\/([^/]+)\/([^/]+)/);
    //         this.uuid =  match[1];
    //       }
    //       const params = {
    //           uuid: this.uuid
    //       }
    //       this.posterImage  = await AssetApi.posterApi(params);
    //     }
    //   } catch (error) {
    //       console.error("getPoster error :", error);
    //   }
    // },
    onPreviousClick() {
      if (this.player && this.isPlaylist) {
        // this.player.playlist.previous();
        if (this.currentIdx === 0) {
          console.log('currentIdx-> first');
          return;
        } else {
          this.currentIdx--;
          //  this.setVolume();
          this.play();
        }
      }
    },
    onNextClick() {
      if (this.player && this.isPlaylist) {
        // this.player.playlist.next();
        if (this.currentIdx === this.videoList.length - 1) {
          console.log('currentIdx-> end');
          return;
        } else {
          this.currentIdx++;
          //  this.setVolume();
          this.play();
        }
      }
    },
    onJumpClick() {
      if (this.player && this.isPlaylist) {
        this.player.playlist.currentItem(2);
      }
    },
    setVolume() {
      // this.$refs.videoPlayer.muted = false;
      this.$refs.videoPlayer.muted = true;
      const volumeInput = document.querySelector('input[data-plyr="volume"]');
      console.log("volumeInput => ", volumeInput)
      if (volumeInput) {
        // volumeInput.value = 1;
        volumeInput.value = 0;
        volumeInput.dispatchEvent(new Event('input'));
      }
    },
    play() {
      //console.log('재생 시작');
      if (this.player && this.player.media) {
        this.player.pause();
      }

      if (this.videoList[this.currentIdx].sources[0].src.indexOf('m3u8') > -1) {
        this.hlsUrl = this.videoList[this.currentIdx].sources[0].src;
      }

      if (this.hlsUrl !== null && Hls.isSupported()) {
        this.hls = new Hls();
        this.hls.loadSource(this.hlsUrl);
        this.hls.attachMedia(this.$refs.videoPlayer);
        this.hls.on(Hls.Events.MANIFEST_PARSED, () => {
          console.log('준비 완료');
          this.$refs.videoPlayer.play();
          this.setVolume();
          this.installCaptionTrack(false);
          this.refreshCaptionMenu(false);
        });
      }
    },
  },
  async mounted() {

    // const types = { mp4: 'video/mp4', webm: 'video/webm', m3u: 'application/x-mpegURL' };
    const frontPreUrl = window.location.protocol + '//' + window.location.host;

    const localurl = window.location.href;

    const url = new URL(localurl);
    const assetParam = url.searchParams.get('assetId')
      || url.searchParams.get('asset_id')
      || url.searchParams.get('asset')
      || url.searchParams.get('aid')
      || url.searchParams.get('id');
    this.assetId = assetParam ? Number(assetParam) || assetParam : null;

    let tmpNumber = url.searchParams.get('url');
    if (tmpNumber) {
      try {
        tmpNumber = decodeURIComponent(tmpNumber);
      } catch (error) {
        // keep original value if decoding fails
      }
    } else {
      const legacy = localurl.replace(frontPreUrl + '/player?', '');
      try {
        tmpNumber = decodeURIComponent(legacy);
      } catch (error) {
        tmpNumber = legacy;
      }
    }

    tmpNumber = (tmpNumber || '').trim();

    if (!tmpNumber) {
      console.error('재생할 URL이 없습니다.');
      return;
    }

    await this.getPoster(tmpNumber);
    await this.loadVideo(tmpNumber);
    this.ensureTranscriptLoaded(false);

  },
  beforeDestroy() {
    if (this.hls) {
      this.hls.destroy();
    }
    if (this.player) {
      this.player.destroy();
    }
    if (this.subtitleSrc) {
      URL.revokeObjectURL(this.subtitleSrc);
    }
    this.stopSubtitleTimer();
    this.clearCaptionTrack();
    this.disposeCustomControls();
  }
};
</script>

<style>
.my-video-container .plyr {
  height: 100%;
  /* 또는 원하는 높이로 지정 */
  width: 100%;

}

.my-video-container {
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  width: 100%;
  height: 100vh;
  /* 수정된 부분 */
  max-height: 100%;
  background-color: rgb(0, 0, 0);
  z-index: 1;
}

.my-video-container video {
  width: 100%;
}

.plyr video {
  height: 100% !important;
}

.video-overlay-buttons {
  position: absolute;
  top: 50%;
  left: 0;
  right: 0;
  transform: translateY(-50%);
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 10px;
  visibility: hidden;
  background: transparent;
  box-shadow: none;
}

.v-btn:before {
  background-color: none;
}

.my-video-container:hover .video-overlay-buttons {
  visibility: visible;
}

.video-previous,
.video-next {
  position: static;
  flex: 0 0 auto;
}

.v-btn.icon {
  height: 50px;
  width: 50px;
  box-shadow: none;
  background: transparent;
}

.v-icon {
  font-size: 24px;
}

.video-overlay-buttons::before,
.video-overlay-buttons::after {
  content: none;
  background: transparent;
}

.video-previous:hover,
.video-next:hover {
  background: transparent;
  box-shadow: none;
}

.subtitle-toggle-control--active {
  color: var(--plyr-color-main, #00b2ff);
}

.subtitle-toggle-label {
  margin-left: 6px;
  font-size: 13px;
}

.subtitle-overlay {
  position: absolute;
  left: 50%;
  bottom: 32px;
  transform: translateX(-50%);
  width: min(90%, 1100px);
  padding: 10px 18px;
  border-radius: 8px;
  background: rgba(0, 0, 0, 0.65);
  color: #fff;
  font-size: clamp(16px, 2.2vw, 30px);
  text-align: center;
  line-height: 1.35;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9;
}
.subtitle-overlay span {
  display: block;
  width: 100%;
  white-space: pre-wrap;
  word-break: break-word;
}
.subtitle-toggle-control {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0 12px;
  height: 36px;
  border-radius: 18px;
  background: rgba(0, 0, 0, 0.45);
  color: #fff;
  border: 1px solid rgba(255, 255, 255, 0.6);
  margin-left: 8px;
  transition: background 0.2s ease, border-color 0.2s ease;
}
.subtitle-toggle-control:hover {
  background: rgba(0, 0, 0, 0.65);
}
.subtitle-toggle-control--active {
  border-color: var(--plyr-color-main, #00b2ff);
  background: rgba(0, 178, 255, 0.25);
}
.subtitle-toggle-control[disabled] {
  opacity: 0.5;
  cursor: not-allowed;
}
.subtitle-toggle-label {
  font-size: 13px;
  line-height: 1;
}
</style>
